// Admin parts of the knowledge base app: its screen (the article's text is written in the core's block editor, decision 034).
import { KnowledgeScreen } from './KnowledgeScreen.tsx';
export { KnowledgeScreen };
/** Special screens of the app: the base in three columns (sections, articles, the article's card). */
export const knowledgeScreens = { knowledge: KnowledgeScreen };
